import { Link } from "react-router-dom";
import backIcon from "../assets/images/back.svg"
import sleepy from "../assets/images/Bunny-sleepy.gif"
import CardForm from "../components/CardForm";
import { HOME } from "../services/consts";

function Create() {
    return(
        <div className="block">
            <div className="container">
                <div className="status">
                    <Link to={HOME} >
                        <img className="back" src={backIcon} alt="back" />
                    </Link>
                    <h1 className="title">Writing..</h1>
                    <div className="empty"></div>
                    <img className="sleepy" src={sleepy} alt="bunny" />
                </div>
                <CardForm />
            </div>
        </div>
    );
}

export default Create;